import * as _ from 'underscore';

export class Stats {
    rowsCount: Array<Object>;
    rowsAvg: Array<any>;
    headers: Array<string>;
    pieData: Object;
    lineData: Array<Object>;
    type: string;

    constructor(){
        this.rowsCount = [];
        this.rowsAvg = [];
        this.headers = [];
        this.pieData = {};
        this.lineData = [];
    }

    hasRowsCount(): boolean{
        return (this.rowsCount.length > 0);
    }

    hasRowsAvg(): boolean{
        return (this.rowsAvg.length > 0);
    }

    hasPieData(): boolean {
        return this.pieData.hasOwnProperty('series') && this.pieData.hasOwnProperty('labels');
    }

    hasLineData(): boolean {
        return this.lineData.hasOwnProperty('labels') && this.lineData.hasOwnProperty('data');
    }

    setRowsCount(data: Object): void{
        this.rowsCount = data['table']['rows_count'];
    }

    setRowsAvg(data: Object): void{
        this.rowsAvg = data['table']['rows_avg'];
    }

    getRowsAvg(){
        return this.rowsAvg;
    }

    setHeaders(data: Object): void{
        this.headers = data['table']['headers'];
    }

    getHeaders(all=false) {
        if (!all) {
            return this.headers;
        }

        let headOrder=[].concat(this.headers);
        headOrder.pop();
        let el=headOrder.shift();
        return headOrder;
    }

    setLineData(data: Object, linesInclude: Array<string> = []): void {

        this.lineData = data['chart']['line_data'];
        this.lineData['labels'] = this.lineData['labels'].filter( (label: string) => { return label != 'Avg'; });
        this.lineData['data'] = this.lineData['data'].map( (obj) => {
            obj['hidden'] = (_.indexOf(linesInclude, obj['label']) >= 0 && obj['label'] != 'Total') ? false : true;
            return obj;
        } );
    }


    getLineData(){
        return this.lineData;
    }


    setPieData(data: Object): void{
        this.pieData = data['chart']['pie_data'];
    }

    setType(type: string): void {
        this.type = type;
    }

    findValueByLabel(rowIdx: number, label: string): string {
        let rowData: Array<Object> = this.rowsAvg[rowIdx];
        let idx = rowData.findIndex( (obj) => {
            return obj['label'] == label;
        } );

        return rowData[idx]['value'];
    }

}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/model/stats.ts